<template lang="pug">
  b-row.p-2(no-gutters)
    b-col(v-if="productsVisible")
      //- b-link#ot_nav_btn1(to="/products" variant="outline-secondary" @mouseover="hoverAppt('ot_nav_btn1')" @mouseout="hoverAppt('ot_nav_btn1')" )
      b-link(to="/products")
        b-img#nav1(:src="alang('section4.product')" fluid )
    
    b-col(v-if="eventsVisible")
      b-link(to="/events")
        b-img#nav2(:src="alang('section4.events')"  fluid )
    
    b-col(v-if="appointmentVisible")
      b-link(to="/appointment" )
        b-img#nav3(:src="alang('section4.appointment')"  fluid )
    
    b-col(v-if="teamVisible")
      b-link(to="/team")
        b-img#nav3(:src="alang('section4.team')"  fluid )
</template>

<script>
import util from '@/common/lang/util'
export default {
  name: 'Section4Widget',
  mixins: [util],
  computed:{
    lang: function(){
      return this.$root.lang;
    },
    productsVisible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section4.products'; }));
    },
    eventsVisible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section4.events'; }));
    },
    appointmentVisible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section4.appointment'; }));
    },
    teamVisible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section4.team'; }));
    }
  },
  methods:{
    hoverNav: function(id){
      console.log(id);
      document.getElementById(id).classList.toggle("bg-primary");
      document.getElementById(id).classList.toggle("bg-outline-secondary");
    },
    nav: function(where){
      this.$router.push(where);
    }
  }
}
</script>